import {selectEventDetailsValid} from '~/CreateFabricInvitation/reducers/details/selectors';
import {UPDATE_EVENT_DETAILS} from '~/common/fabric/reducers/details/constants';

export const validateEventDetails = async (store) => {
  const valid = selectEventDetailsValid(store.getState(), false);
  if (!valid) {
    return valid;
  }
  if (!valid) {
    store.dispatch({
      type: UPDATE_EVENT_DETAILS,
      payload: {request: {failed: true}},
    });
    return false; // Prevent navigation
  }
  store.dispatch({
    type: UPDATE_EVENT_DETAILS,
    payload: {request: {failed: false}},
  });
  return true; // Allow navigation
};

export const EMPTY_DATE_TIME_ERROR = 'Add date and time';
export const PAST_EVENT_DATE_ERROR = 'The date and time cannot be in the past';
export const END_BEFORE_START_ERROR = 'End date cannot be before start date';
